import ReduxActionInterface from '../../model/ReduxActionInterface';
import ReduxRootState from '../../model/Redux/ReduxRootSate';

import * as TopinvestorsActionType from './actionsType';


export interface TopInvestorsReducer extends Omit<ReduxRootState, 'data'> {
    data: []
}
const ROOT_VALUE_STATE: TopInvestorsReducer = {
    loading: false,
    data:[],
   
};


export const topInvestorsReducer = (state: TopInvestorsReducer = ROOT_VALUE_STATE, action: ReduxActionInterface) => {
  
    switch (action.type) {
        case TopinvestorsActionType.TOP_INVESTORS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case TopinvestorsActionType.TOP_INVESTORS_ERROR:

            return {
                ...state,
                loading: false,
            };

        case TopinvestorsActionType.TOP_INVESTORS_SUCCESS:
            return {
                ...state,
                   
                    data: action.payload.data,
                    isAuthenticated: true,
                
                loading: false,
            };

        default: return state;
    }
};
